import { Sheet, SheetEventType } from "../../../siteManagement/sheet";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, Entity } from "../../core/components/commonApp";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Grid } from "../../core/components/grid";
import { TextBox } from "../../core/components/textBox";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { FontAwesomePicker } from "../../fontAwesome/FontAwesomePicker";
import EditTranslations from "../editTranslations";
import EditTranslationsInGrid, { UebersetungInGrid } from "../editTranslationsInGrid";
import React from "react";
export default class PushNotificationsStateGrid extends React.Component<PushNotificationsStateGridProps, PushNotificationStateGridState>{
    common = new AppHelper();
    gridOptions: {} = null;
    editTranslationsRef: EditTranslations = null;
    factory = ComponentHelper.createFactory();
    translations: string[] = null;
    private translationInGridRef: EditTranslationsInGrid;


    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (Helper.hasValue(this.state.selectedValue.Description)) {
                        this.save();
                    } else {
                        DialogHelper.alert(this.translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            selectedValue: null,
            gridData: null
        }
    }

    componentDidMount() {
        this.translations = this.props.context.translations;
        this.gridOptions = this.props.context.pushNotificationStateGridOptions;
        this.loadGridData();
    }

    private loadGridData = async () => {
        const result = await HTTPService.get<JsonResultClass>("PushNotifications/GetPushNotificationStates");
        if (result.Code == 0)
            this.setState({ gridData: result.Data })
    }

    private save = async () => {
        let result = await HTTPService.post<JsonResultClass<void>>("PushNotifications/Save", this.state.selectedValue);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(this.translations["Standard.Msg.SpeichernErfolgreich"]);
            this.loadGridData();
            return true;
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
            return false;
        }
    }

    createDialog = () => {
        if (this.state.dialogOpen) {
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                        <FullHeightContainer>
                            {this.createTextBox("key")}
                            {this.createFontAwesomePicker()}
                            {this.createTextBox("text")}
                            {this.createTranslationsInGrid()}
                        </FullHeightContainer>
                    </Dialog>
                </div>
            );
        } else {
            return (<></>);
        }
    }

    private createTranslationsInGrid = () => {
        let translationColumns = [
            {
                visible: true,
                width: "100",
                field: "Value0",
                title: Helper.getTranslation("Standard.Name")
            }
        ];

        return <EditTranslationsInGrid
            id={"editPushNotificationTranslationsInGrid"}
            gridData={this.state.selectedValue.Translations}
            translationColumns={translationColumns}
            setEntityDirtyState={(isDirty) => this.common.setEntityDirtyState(isDirty)}
            ref={(ref) => this.translationInGridRef = ref} />
    }

    private createFontAwesomePicker = () => {
        let label = "Icon"
        return (<FieldInstance label={label} noHover={true}>
            <FontAwesomePicker value={this.state.selectedValue.Icon}
                onIconSelected={(value) => {
                    let item = this.state.selectedValue;
                    item.Icon = value;
                    this.setState({ selectedValue: item });
                }} />
        </FieldInstance>);
    }

    private createTextBox = (type: string) => {
        let props = this.factory.getDefaultTextBoxProps();
        let label = "";
        switch (type) {
            case "key":
                label = this.translations["Standard.Key"];
                props.disabled = true;
                props.value = this.state.selectedValue.State;
                break;
            case "text":
                label = this.translations["WebCRM.EditIndividualFields.DefaultDesignation"];
                props.value = this.state.selectedValue.Description;
                props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                    let item = this.state.selectedValue;
                    item.Description = value;
                    this.setState({ selectedValue: item });
                }
                break;
        }
        return (
            <FieldInstance label={label} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });

        let grid = null;
        if (Helper.hasValue(this.state.gridData) && Helper.hasValue(this.gridOptions)) {
            grid = (
                <div className="flex-container" style={{ height: "350px" }}>
                    <Grid data={this.state.gridData} options={this.gridOptions} id="PushNotificationStates"
                        standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton}
                        onSelectionChanged={this.handleSelectionChanged} />
                </div>
            );
        }
        return (grid)
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: PushNotificationState) => {
        let sheet: Sheet;
        if (type == ToolBarStandardButtonType.EDIT) {
            this.setState({ dialogOpen: true });
        }
        if (Helper.hasValue(sheet)) {
            sheet.bind(SheetEventType.Close, this.loadGridData);
        }
    }

    handleSelectionChanged = (dataItem: PushNotificationState) => {
        if (!this.state.dialogOpen)
            this.setState({ selectedValue: dataItem });
    }

    render() {
        const grid = this.createGrid();
        const dialog = this.state.dialogOpen ? this.createDialog() : null;
        return (
            <>
                {grid}
                {dialog}
            </>
        );
    }
}

interface PushNotificationsStateGridProps extends AppBaseProps {
    context: any;
    entity: any;
}

interface PushNotificationStateGridState {
    dialogOpen: boolean;
    selectedValue: PushNotificationState;
    gridData: PushNotificationState[];
}

interface PushNotificationState extends Entity {
    State?: number;
    IsRowId?: number;
    Description?: string;
    DescriptionTranslated?: string;
    Icon?: string;
    Translations?: UebersetungInGrid[];
}
